export function validateCredentials(login: string, password: string): string | null {
  if (!login.trim()) return 'Введите логин';
  if (!password) return 'Введите пароль';
  return null;
}
